/*
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the MIT license.
*/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define(["require", "exports", "azure-devops-ui/Card", "azure-devops-ui/Core/Util/String", "azure-devops-ui/Header", "azure-devops-ui/Link", "azure-devops-ui/Page", "azure-devops-ui/Spinner", "azure-devops-ui/TooltipEx", "azure-devops-ui/Utilities/Date", "history", "react", "simple-query-string", "../../Resources", "../Common/KubeCardWithTable", "../Common/KubeZeroData", "../Common/PageTopHeader", "../Common/Tags", "../Constants", "../FluxCommon/ActionsCreatorManager", "../FluxCommon/StoreManager", "../ImageDetails/ImageDetails", "../ImageDetails/ImageDetailsActionsCreator", "../ImageDetails/ImageDetailsStore", "../KubeFactory", "../Pods/PodsActionsCreator", "../Pods/PodsStore", "../Pods/PodsTable", "../RunDetails", "../Selection/SelectionActionCreator", "../Utils", "./WorkloadsActionsCreator", "./WorkloadsStore", "./WorkloadDetails.scss"], function (require, exports, Card_1, String_1, Header_1, Link_1, Page_1, Spinner_1, TooltipEx_1, Date_Utils, history_1, React, queryString, Resources, KubeCardWithTable_1, KubeZeroData_1, PageTopHeader_1, Tags_1, Constants_1, ActionsCreatorManager_1, StoreManager_1, ImageDetails_1, ImageDetailsActionsCreator_1, ImageDetailsStore_1, KubeFactory_1, PodsActionsCreator_1, PodsStore_1, PodsTable_1, RunDetails_1, SelectionActionCreator_1, Utils_1, WorkloadsActionsCreator_1, WorkloadsStore_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WorkloadDetails = /** @class */ (function (_super) {
        __extends(WorkloadDetails, _super);
        function WorkloadDetails(props) {
            var _this = _super.call(this, props, {}) || this;
            _this._showImageDetails = function (imageId) {
                var showImageDetails = function (imageDetails) {
                    _this.setState({
                        showImageDetails: true,
                        selectedImageDetails: imageDetails
                    });
                };
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator).getImageDetails(imageId, showImageDetails);
            };
            _this._hideImageDetails = function () {
                _this.setState({
                    showImageDetails: false,
                    selectedImageDetails: undefined
                });
            };
            _this._onPodsUpdated = function () {
                var podsStoreState = _this._podsStore.getState();
                var podList = podsStoreState.podsList;
                if (podList && podList.items) {
                    var imageList = Utils_1.Utils.getImageIdsForPods(podList.items);
                    _this.setState({
                        pods: podList.items.filter(function (p) { return _this.state.item && Utils_1.Utils.isOwnerMatched(p.metadata, _this.state.item.metadata.uid); }),
                        arePodsLoading: podsStoreState.isLoading,
                        imageList: imageList
                    });
                }
            };
            _this._markTTI = function () {
                if (!_this._isTTIMarked) {
                    KubeFactory_1.getTelemetryService().scenarioEnd(Constants_1.Scenarios.WorkloadDetails);
                }
                _this._isTTIMarked = true;
            };
            _this._onSelectedPodInvoked = function (event, pod) {
                var selectionActionCreator = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(SelectionActionCreator_1.SelectionActionsCreator);
                selectionActionCreator.selectItem({
                    item: undefined,
                    itemUID: pod.metadata.uid,
                    selectedItemType: "pod-details" /* PodDetailsKey */,
                    showSelectedItem: true,
                    properties: {
                        parentUid: (_this.state.item && _this.state.item.metadata.uid) || "",
                    }
                });
            };
            _this._setHasImageDetails = function () {
                _this.setState({});
            };
            _this._isTTIMarked = false;
            KubeFactory_1.getTelemetryService().scenarioStart(Constants_1.Scenarios.WorkloadDetails);
            _this._podsStore = StoreManager_1.StoreManager.GetStore(PodsStore_1.PodsStore);
            _this._imageDetailsStore = StoreManager_1.StoreManager.GetStore(ImageDetailsStore_1.ImageDetailsStore);
            _this._podsStore.addListener(Constants_1.PodsEvents.PodsFetchedEvent, _this._onPodsUpdated);
            _this._imageDetailsStore.addListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, _this._setHasImageDetails);
            _this._workloadsStore = StoreManager_1.StoreManager.GetStore(WorkloadsStore_1.WorkloadsStore);
            var notifyViewChanged = function (item) {
                if (item.metadata && props.notifyViewChanged) {
                    var metadata = item.metadata;
                    props.notifyViewChanged([{ id: props.itemTypeKey + metadata.uid, displayName: metadata.name, url: window.location.href }]);
                }
            };
            var item = props.item;
            if (!props.item) {
                var kubeService_1 = KubeFactory_1.KubeFactory.getKubeService();
                ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(PodsActionsCreator_1.PodsActionsCreator).getPods(kubeService_1);
                var workloadsActionCreator_1 = ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(WorkloadsActionsCreator_1.WorkloadsActionsCreator);
                var history_2 = history_1.createBrowserHistory();
                var queryParams_1 = queryString.parse(history_2.location.search);
                if (queryParams_1.type) {
                    // function to make sure we get the item for the view if present, or we make a call and set up a store listener to fetch that item
                    var getItem = function (getItemList, actionCreatorFunc, storeEvent) {
                        // function to search the relevant item from the item list provided
                        var searchItem = function () {
                            var itemList = getItemList();
                            if (itemList && itemList.items) {
                                return itemList.items.find(function (i) { return i.metadata.uid === queryParams_1.uid; });
                            }
                        };
                        var itemToReturn = searchItem();
                        if (!itemToReturn) {
                            var subscription_1 = function () {
                                var item = searchItem();
                                _this._workloadsStore.removeListener(storeEvent, subscription_1);
                                if (item) {
                                    notifyViewChanged(item);
                                }
                                _this.setState({ item: item });
                            };
                            actionCreatorFunc(kubeService_1);
                            _this._workloadsStore.addListener(storeEvent, subscription_1);
                        }
                        return itemToReturn;
                    };
                    switch (queryParams_1.type) {
                        case "replica-set" /* ReplicaSetKey */:
                            item = getItem(function () { return _this._workloadsStore.getState().replicaSetList; }, function (k) { return workloadsActionCreator_1.getReplicaSets(k); }, Constants_1.WorkloadsEvents.ReplicaSetsFetchedEvent);
                            break;
                        case "daemon-set" /* DaemonSetKey */:
                            item = getItem(function () { return _this._workloadsStore.getState().daemonSetList; }, function (k) { return workloadsActionCreator_1.getDaemonSets(k); }, Constants_1.WorkloadsEvents.DaemonSetsFetchedEvent);
                            break;
                        case "stateful-set" /* StatefulSetKey */:
                            item = getItem(function () { return _this._workloadsStore.getState().statefulSetList; }, function (k) { return workloadsActionCreator_1.getStatefulSets(k); }, Constants_1.WorkloadsEvents.StatefulSetsFetchedEvent);
                            break;
                    }
                }
            }
            if (item) {
                notifyViewChanged(item);
            }
            _this.state = {
                item: item,
                pods: [],
                selectedPod: null,
                showSelectedPod: false,
                showImageDetails: false,
                selectedImageDetails: undefined
            };
            return _this;
        }
        WorkloadDetails.prototype.render = function () {
            if (this.state.showImageDetails && this.state.selectedImageDetails) {
                return React.createElement(ImageDetails_1.ImageDetails, { imageDetails: this.state.selectedImageDetails, onBackButtonClick: this._hideImageDetails });
            }
            return (React.createElement(Page_1.Page, { className: "workload-details-page flex flex-grow" },
                this._getMainHeading(),
                React.createElement("div", { className: "workload-details-page-content page-content page-content-top" },
                    this._getWorkloadDetails(),
                    this._getAssociatedPods())));
        };
        WorkloadDetails.prototype.componentDidMount = function () {
            var _this = this;
            if (this.state.item) {
                var podList = this._podsStore.getState().podsList;
                var pods = (podList && podList.items || []).filter(function (pod) {
                    return Utils_1.Utils.isOwnerMatched(pod.metadata, _this.state.item.metadata.uid);
                });
                this.setState({
                    pods: pods,
                    selectedPod: pods && pods.length > 0 ? pods[0] : null
                });
            }
        };
        WorkloadDetails.prototype.componentDidUpdate = function (prevProps, prevState) {
            // Fetch hasImageDetailsData if we directly refresh and land on WorkloadDetails
            var imageService = KubeFactory_1.KubeFactory.getImageService();
            if (imageService && this.state.imageList && this.state.imageList.length > 0) {
                var hasImageDetails = this._imageDetailsStore.hasImageDetails(this.state.imageList[0]);
                if (hasImageDetails === undefined) {
                    ActionsCreatorManager_1.ActionsCreatorManager.GetActionCreator(ImageDetailsActionsCreator_1.ImageDetailsActionsCreator).setHasImageDetails(imageService, this.state.imageList);
                }
            }
        };
        WorkloadDetails.prototype.componentWillUnmount = function () {
            this._podsStore.removeListener(Constants_1.PodsEvents.PodsFetchedEvent, this._onPodsUpdated);
            this._imageDetailsStore.removeListener(Constants_1.ImageDetailsEvents.HasImageDetailsEvent, this._setHasImageDetails);
        };
        WorkloadDetails.prototype._getMainHeading = function () {
            if (this.state.item) {
                var metadata = this.state.item.metadata;
                var _a = this.props.getStatusProps(this.state.item), statusProps = _a.statusProps, podsTooltip = _a.podsTooltip;
                return !metadata ? null
                    : React.createElement(PageTopHeader_1.PageTopHeader, { className: "wl-header", title: metadata.name, statusProps: statusProps, statusTooltip: podsTooltip });
            }
            return null;
        };
        WorkloadDetails.prototype._getWorkloadDetails = function () {
            if (this.state.item) {
                var metadata = this.state.item.metadata;
                if (metadata) {
                    var agoTime = Date_Utils.ago(new Date(metadata.creationTimestamp), 0 /* Compact */);
                    return (React.createElement(Card_1.CustomCard, { className: "workload-details-card k8s-card-padding flex-grow bolt-card-no-vertical-padding" },
                        React.createElement(Header_1.CustomHeader, null,
                            React.createElement(Header_1.HeaderTitleArea, null,
                                React.createElement(Header_1.HeaderTitleRow, null,
                                    React.createElement(Header_1.HeaderTitle, { className: "text-ellipsis", titleSize: 0 /* Medium */ }, String_1.localeFormat(Resources.WorkloadDetails, this.props.parentKind))),
                                React.createElement(Header_1.HeaderDescription, { className: "text-ellipsis" }, RunDetails_1.getRunDetailsText(metadata.annotations, undefined, agoTime)))),
                        React.createElement(Card_1.CardContent, { className: "workload-full-details-table" }, this._getWorkloadDetailsCardContent())));
                }
            }
            return null;
        };
        WorkloadDetails.prototype._getWorkloadDetailsCardContent = function () {
            var _this = this;
            var workloadDetails = [];
            if (this.state.item) {
                workloadDetails.push({ key: Resources.ImageText, value: this.state.item.spec && this.state.item.spec.template });
                workloadDetails.push({ key: Resources.SelectorText, value: this.state.item.spec && this.state.item.spec.selector && this.state.item.spec.selector.matchLabels || {} });
                workloadDetails.push({ key: Resources.LabelsText, value: this.state.item.metadata && this.state.item.metadata.labels || {} });
            }
            return (React.createElement("div", { className: "flex-row workload-card-content" }, workloadDetails.map(function (item, index) { return _this._renderWorkloadCellContent(item, index); })));
        };
        WorkloadDetails.prototype._renderWorkloadCellContent = function (item, index) {
            var key = item.key, value = item.value;
            var getColumnKey = function (keyText, keyClassName) {
                var computedCLassName = "secondary-text workload-column-key-padding " + (keyClassName || "");
                return React.createElement("div", { className: computedCLassName }, keyText);
            };
            switch (key) {
                case Resources.ImageText:
                    return (React.createElement("div", { className: "flex-column body-m workload-image-column-size", key: index },
                        getColumnKey(key),
                        this._renderImageCell(value)));
                case Resources.LabelsText:
                case Resources.SelectorText:
                    return (React.createElement("div", { className: "flex-grow flex-column workload-tags-column-padding", key: index },
                        getColumnKey(key, "body-m"),
                        React.createElement(Tags_1.Tags, { className: "overflow-fade workload-tags-column-size", items: value })));
                default:
                    return undefined;
            }
        };
        WorkloadDetails.prototype._renderImageCell = function (itemValue) {
            var _this = this;
            var imageId = Utils_1.Utils.getImageIdForWorkload(Utils_1.Utils.getFirstContainerName(itemValue.spec), this.state.pods);
            var _a = Utils_1.Utils.getImageText(itemValue.spec), imageText = _a.imageText, imageTooltipText = _a.imageTooltipText;
            var imageDetailsUnavailableTooltipText = "";
            var hasImageDetails = this._imageDetailsStore.hasImageDetails(imageId);
            // if hasImageDetails is undefined, then image details promise has not resolved, so do not set imageDetailsUnavailable tooltip
            if (hasImageDetails === false) {
                var imageValueText = imageTooltipText || imageText;
                imageDetailsUnavailableTooltipText = String_1.localeFormat("{0} | {1}", imageValueText, Resources.ImageDetailsUnavailableText);
            }
            var itemToRender = hasImageDetails ?
                React.createElement(TooltipEx_1.Tooltip, { overflowOnly: true },
                    React.createElement("div", { className: "flex-row flex-center" },
                        React.createElement(Link_1.Link, { className: "fontSizeM font-size-m text-ellipsis bolt-table-link workload-image-padding", rel: "noopener noreferrer", onClick: function (e) {
                                e.preventDefault();
                                _this._showImageDetails(imageId);
                            } }, imageText)))
                : KubeCardWithTable_1.defaultColumnRenderer(imageText, "", imageDetailsUnavailableTooltipText);
            return itemToRender;
        };
        WorkloadDetails.prototype._getAssociatedPods = function () {
            var _this = this;
            var podsStoreState = this._podsStore.getState();
            if (podsStoreState.isLoading) {
                return React.createElement(Spinner_1.Spinner, { className: "flex flex-grow loading-pods", size: "large" /* large */, label: Resources.LoadingPodsSpinnerLabel });
            }
            if (this.state.pods.length === 0) {
                setTimeout(function () { return _this._markTTI(); }, 0);
                return KubeZeroData_1.KubeZeroData.getWorkloadAssociatedPodsZeroData();
            }
            return (React.createElement(PodsTable_1.PodsTable, { contentClassName: "workload-pods-table", podsToRender: this.state.pods, headingText: Resources.PodsText, onItemActivated: this._onSelectedPodInvoked, markTTICallback: this._markTTI }));
        };
        return WorkloadDetails;
    }(React.Component));
    exports.WorkloadDetails = WorkloadDetails;
});
